import { Suspense, lazy, useContext, useEffect, useRef, useState } from "react";
import uuid from "react-uuid";
import { Simplebar } from "../Simplebar/Simplebar";
import { ActividadesContext } from "../../Contexts/index";
import SuspenseCRM from "../Suspense/SuspenseCRM";
import SolicitudEdit from "../../Views/Solicitudes/SolicitudEdit";
import { FUENTE_CASO, FUENTE_CUENTA } from "../../Utils";
export const ActividadSimplebar = ({
  type,
  showCanvas,
  setShowCanvas,
  fuente,
  referencia,
  afterSave,
  entidadNombre,
  cuentaList = [],
  contactoList = [],
  config,
  prospectoList = [],
  refreshView = () => {},
}) => {
  let actividadesContext = useContext(ActividadesContext);
  let setFuente;
  let setReferencia;

  if (actividadesContext) {
    setFuente = actividadesContext.setFuente;
    setReferencia = actividadesContext.setReferencia;
  }
  useEffect(() => {
    if (setFuente) {
      setFuente(fuente);
    }

    if (setReferencia) {
      setReferencia(referencia);
    }
  }, [
    setFuente,
    setReferencia,
    fuente,
    referencia,
    showCanvas,
    setShowCanvas,
    type,
    afterSave,
    config,
  ]);

  const casoRef = useRef(null);
  const casoSideRef = useRef(null);
  const [showCaso, setShowCaso] = useState(false);

  const [cotizacionKey, setCotizacionKey] = useState("cot-edit");

  const casoEdit = (
    <SolicitudEdit
      esModal={true}
      esView
      fuente={fuente}
      referencia={referencia}
      afterSave={afterSave}
      showLoading={() => casoSideRef?.current?.showLoading?.(true)}
      hideLoading={() => casoSideRef?.current?.showLoading?.(false)}
      ref={casoRef}
      cuentaIdSec={fuente === FUENTE_CUENTA ? referencia : null}
      cuentaNombre={entidadNombre}
    />
  );

  const casoFunc = () => {
    casoRef.current?.grabar().then((result) => {
      if (result) {
        refreshView(referencia);
        setShowCanvas(false);
        setShowCaso(false);
      }
    });
  };

  const SimplebarCaso = (
    <Simplebar
      title="Crear Solicitud"
      ref={casoSideRef}
      key={"simpleBar-container-caso-"}
      backdrop={true}
      placement={"end"}
      portal={false}
      visible={showCaso}
      setShow={(e) => {
        setShowCaso(e);
        setShowCanvas(e);
      }}
      useLoading={true}
      size="lg"
      btnLeft={{
        show: true,
        message: "Grabar",
        isComponent: true,
        size: "45px",
        height: "24px",
        with: "24px",
        iconName: "save",
        isCenter: true,
        func: casoFunc,
      }}
      btnRight={{
        show: false,
        label: "Grabar",
        func: () => {},
      }}
    >
      {casoEdit}
    </Simplebar>
  );

  useEffect(() => {
    if (showCanvas) {
      switch (type) {
        case FUENTE_CASO:
          setShowCaso(true);
          break;
        default:
          setShowCaso(true);
          break;
      }
    } else {
      setShowCaso(false);
    }
  }, [type, showCanvas, afterSave]);

  return (
    <>
      <Suspense fallback={<SuspenseCRM />}>
        {showCaso && <div>{SimplebarCaso}</div>}
      </Suspense>
    </>
  );
};
